import type { ButtonHTMLAttributes, PropsWithChildren } from "react";
import type { LucideIcon } from "lucide-react";

export type ButtonVariant = "primary" | "secondary" | "quiet";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
}

export function Button({
  variant = "primary",
  className = "",
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      className={`chams-button chams-button--${variant} ${className}`.trim()}
      type={type}
      {...props}
    />
  );
}

export interface IconProps {
  readonly icon: LucideIcon;
  readonly directional?: boolean;
  readonly small?: boolean;
}

export function Icon({ icon: Glyph, directional = false, small = false }: IconProps) {
  const className = [
    "chams-icon",
    small ? "chams-icon--small" : "",
    directional ? "chams-icon--directional" : "",
  ]
    .filter(Boolean)
    .join(" ");
  return <Glyph aria-hidden="true" className={className} strokeWidth={1.8} />;
}

export interface StatusPillProps extends PropsWithChildren {
  readonly tone?: "neutral" | "success" | "warning" | "error";
}

export function StatusPill({ tone = "neutral", children }: StatusPillProps) {
  const toneClass = tone === "neutral" ? "" : `chams-pill--${tone}`;
  return <span className={`chams-pill ${toneClass}`.trim()}>{children}</span>;
}

export function Bidi({ children }: PropsWithChildren) {
  return (
    <bdi className="chams-bidi" dir="ltr">
      {children}
    </bdi>
  );
}
